// Header height changes on rotation, resize, alerts and patient selection. Update
// the content offset without calling the global helper that scrolls to the top.
export default {
    mounted() {
        this.$nextTick(() => {
            this._clinicalResize = () => {
                if (this._isDestroyed || this._isBeingDestroyed) return;
                const header = this.$refs.screenHeader;
                const content = this.$refs.screenContent;
                if (!header || !content) return;
                content.style.paddingTop = `${header.offsetHeight + 8}px`;
                const footer = this.$refs.screenFooter;
                if (footer) content.style.paddingBottom = `${footer.offsetHeight + 16}px`;
            };
            window.addEventListener('resize', this._clinicalResize);
            if (typeof ResizeObserver !== 'undefined' && this.$refs.screenHeader) {
                this._clinicalHeaderObserver = new ResizeObserver(this._clinicalResize);
                this._clinicalHeaderObserver.observe(this.$refs.screenHeader);
                if (this.$refs.screenFooter) this._clinicalHeaderObserver.observe(this.$refs.screenFooter);
            }
            this._clinicalResize();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this._clinicalResize);
        if (this._clinicalHeaderObserver) this._clinicalHeaderObserver.disconnect();
    }
};
